import styled from 'styled-components';

import { spaceL, spaceM, spaceXXL, xdlColorText } from '@xingternal/tokens';
import { Column, Row } from '@xingternal/xing-grid';

import { ActionsContainer } from '@/components/posting-header-actions';
import Navigation from '@/components/posting-header/components/navigation';

export const StyledRow = styled(Row)`
  display: flex;
  justify-content: space-between;
  margin-top: ${spaceM};

  & svg {
    color: ${xdlColorText};
  }
`;

export const MobileActionsContainer = styled(ActionsContainer)`
  padding-bottom: ${spaceL};
  width: 100%;
`;

export const StyledNavigation = styled(Navigation)`
  padding-bottom: ${spaceXXL};
`;

export const PublishedDateRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TitleWrapper = styled(Column)`
  display: flex;
  flex-direction: column;
`;
